import React, { useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import Image1 from "../../../assets/carousel/1.webp";
import Image2 from "../../../assets/carousel/2.webp";
import Image3 from "../../../assets/carousel/3.webp";
import Image4 from "../../../assets/carousel/4.webp";
import Image5 from "../../../assets/carousel/5.webp";
import Image1g from "../../../assets/carousel/1g.webp";
import Image2g from "../../../assets/carousel/2g.webp";
import Image3g from "../../../assets/carousel/3g.webp";
import Image4g from "../../../assets/carousel/4g.webp";
import Image5g from "../../../assets/carousel/5g.webp";
import { useSelector } from "react-redux";
import { selectCurrentLanguage } from "../../../features/langSlice";
import { Icon } from "../../elements/icon";
import { useTranslation } from "react-i18next";
import {
  Nutrient,
  Quantity,
  IncludesCarousel,
  NutrientsCarousel,
  ViewFormula,
  Ingredients,
} from "../../../Constants";
import FormulaSS from "../../../assets/formula-ss.png";
const images = [
  { en: Image1, de: Image1g },
  { en: Image2, de: Image2g },
  { en: Image3, de: Image3g },
  { en: Image4, de: Image4g },
  { en: Image5, de: Image5g },
];

const CarouselProduct = ({
  data = [],
  allIngredients,
  allIngredientCodes,
  onClickViewFormula,
  name,
}) => {
  const selectedLang = useSelector(selectCurrentLanguage);
  const [currentSlide, setCurrentSlide] = useState(0);
  const { t } = useTranslation();

  return (
    <div className="t-relative">
      <Carousel
        selectedItem={currentSlide}
        onChange={(index) => setCurrentSlide(index)}
        showArrows={true}
        showIndicators={false}
        showThumbs={false}
        showStatus={false}
        className="container"
        renderArrowPrev={(onClickHandler, hasPrev, label) => (
          <Icon
            name="chevronLeft"
            onClick={hasPrev ? onClickHandler : undefined}
            className={`t-absolute -t-left-1 t-top-[45%] t-rounded-[0_8px_8px_0] t-p-1 t-w-8 t-h-8 t-z-10
              ${
                hasPrev
                  ? "t-bg-white t-text-black t-shadow-md hover:t-bg-gray-200"
                  : "t-bg-gray-300 t-text-gray-500 t-cursor-not-allowed t-opacity-50"
              }`}
          />
        )}
        renderArrowNext={(onClickHandler, hasNext, label) => (
          <Icon
            name="chevronRight"
            onClick={hasNext ? onClickHandler : undefined}
            className={`t-absolute -t-right-1 t-top-[45%] t-rounded-[8px_0_0_8px] t-p-1 t-w-8 t-h-8 t-z-10
              ${
                hasNext
                  ? "t-bg-white t-text-black t-shadow-md hover:t-bg-gray-200"
                  : "t-bg-gray-300 t-text-gray-500 t-cursor-not-allowed t-opacity-50"
              }`}
          />
        )}
      >
        <div className=" !t-w-full t-flex t-flex-col t-gap-2 t-overflow-x-auto t-p-2 t-border t-border-gray-200 t-rounded-lg">
          <div className="t-flex t-items-center t-justify-between t-gap-4">
            <div className="t-flex t-flex-col t-items-start">
              <h1
                className="!t-m-0 !t-text-secondary !t-font-extrabold"
                style={{ fontFamily: "Roboto" }}
              >
                {name}
              </h1>
              <p className="!t-m-0 t-text-gray-500">
                {t(IncludesCarousel)} {data?.length} {t(NutrientsCarousel)}
              </p>
            </div>
            <button
              className="btn btn-secondary !t-bg-quaternary !t-text-white !t-border-0 !t-rounded-lg !t-px-2"
              onClick={onClickViewFormula}
            >
              {t(ViewFormula)}
            </button>
          </div>
          <table className="table accordion" id="accordionExample">
            <thead>
              <tr>
                <td className="t-text-sm !t-text-left !t-font-bold">
                  {t(Nutrient)}
                </td>
                <td className="t-text-sm t-font-bold !t-text-gray-500">
                  {t(Quantity)}
                </td>
                <td className="t-text-sm t-font-bold !t-text-gray-500">%NRV</td>
              </tr>
            </thead>
            <tbody>
              {data &&
                data?.slice(0, 6).map((item, i) => {
                  const ingredient = allIngredients?.data?.find(
                    (ing) =>
                      ing.ingredient === item?.ingredient ||
                      ing.ingredient_de === item?.ingredient
                  );
                  const ingredientData = allIngredientCodes?.data?.find(
                    (ing) => ing?.code === ingredient?.id
                  );
                  return (
                    <tr>
                      <td className="t-text-sm !t-text-left !t-font-bold">
                        {item.ingredient}
                      </td>
                      <td className="t-text-sm t-font-bold !t-text-gray-500">
                        {item?.daily_dose} mg
                      </td>
                      <td className="t-text-sm t-font-bold !t-text-gray-500">
                        {parseFloat(ingredientData?.eu_nrv) <= 0
                          ? "*"
                          : `${item.per_eu_nrv}%`}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <button
            onClick={onClickViewFormula}
            className="!t-mx-auto t-text-base !t-text-secondary t-flex t-flex-row i-justify-center t-items-center  -t-mt-4 t-gap-0"
          >
            <Icon name="chevronDown" size="32" color="#005d67" />
            {data?.length} {t(Ingredients)}
          </button>
        </div>
        {images.map((img, index) => (
          <div key={index}>
            <img src={selectedLang === "de" ? img.de : img.en} alt="" />
          </div>
        ))}
      </Carousel>
      <div className="t-flex t-justify-center t-gap-2 t-mt-4 t-overflow-x-auto t-px-2">
        <div
          onClick={() => setCurrentSlide(0)}
          className={`t-h-12 t-w-12 t-flex t-items-center t-justify-center t-bg-white t-border-2 t-cursor-pointer ${
            currentSlide === 0
              ? "t-border-black t-opacity-100"
              : "t-border-transparent t-opacity-60 hover:t-opacity-100"
          }`}
        >
          <img src={FormulaSS} alt="" />
        </div>

        {images.map((img, index) => {
          const actualIndex = index + 1;
          const isActive = actualIndex === currentSlide;
          return (
            <img
              key={index}
              src={selectedLang === "de" ? img.de : img.en}
              alt={`Thumb ${index + 1}`}
              onClick={() => setCurrentSlide(actualIndex)}
              className={`t-h-12 t-w-12 t-object-cover t-cursor-pointer t-transition-all t-border-2 ${
                isActive
                  ? "t-border-black t-opacity-100"
                  : "t-border-transparent t-opacity-60 hover:t-opacity-100"
              }`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default CarouselProduct;
